import React from 'react';
import { Navigate, Outlet, Route } from 'react-router';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import UnregisterPageRoute from './UnregisterPageRoute';

const basePath = '/v2/info/apps';

export default (
  <Route
    path={basePath}
    element={
      <MainLayout>
        <Outlet />
      </MainLayout>
    }
  >
    <Route index element={<Navigate replace to={`${basePath}/unregister`} />} />
    <Route path={`${basePath}/unregister/*`} element={<UnregisterPageRoute />} />
    <Route path="*" element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
  </Route>
);
